import { render, staticRenderFns } from "./ProcessingProfilesEdit.vue?vue&type=template&id=62caa331&"
import script from "./ProcessingProfilesEdit.vue?vue&type=script&lang=ts&"
export * from "./ProcessingProfilesEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab})
